// src/api/doctemp.js
import api from "./axios";

const BASE = "doctemp/templates/";

// 기본 템플릿 조회
export const resolveTemplate = (params) =>
  api.get(`${BASE}resolve/`, { params }).then((r) => r.data);

// 템플릿 목록(버전 목록)
export const listTemplateVersions = (params) =>
  api.get(BASE, { params }).then((r) => r.data);

// 단건 조회
export const getTemplateById = (id) =>
  api.get(`${BASE}${id}/`).then((r) => r.data);

// 새 템플릿(=새 버전) 생성
export const createTemplate = (payload) =>
  api.post(BASE, payload).then((r) => r.data);

// 기본 지정 (빈 객체를 같이 보내 안전성↑)
export const setDefaultTemplate = (id) =>
  api.post(`${BASE}${id}/set-default/`, {}).then((r) => r.data);

// 업데이트(제목/설명 등)
export const updateTemplate = (id, payload) =>
  api.patch(`${BASE}${id}/`, payload).then((r) => r.data);

// 삭제 (204 대응)
export const deleteTemplate = async (id) => {
  await api.delete(`${BASE}${id}/`);
  return true;
};
